const ratingValues = [
  {
    value: '1',
    text: 'Nada o nunca'
  },
  {
    value: '2',
    text: 'Poco o raras veces'
  },
  {
    value: '3',
    text: 'Algunas veces'
  },
  {
    value: '4',
    text: 'Bastante o frecuentemente'
  },
  {
    value: '5',
    text: 'Muchísimo o siempre'
  }
];

const questionHeader = {
  type: 'html',
  name: 'HTML_QUESTION_Header',
  html: `
  <div class="">
    <span style="font-size:16px;">
      Por favor indica en qué medida esta afirmación te representa:
    </span>
    <br />
    <br />
  </div>
  `
};

export const TestIntro = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  firstPageIsStarted: false,
  showPrevButton: false,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'EE_PAGE_00_T',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01',
          html: `
  <div class="QuestionText BorderColor">
    <span style="font-size:16px;">
      <span style="font-family:arial,helvetica,sans-serif;">
        <h3>Sección 4/5</h3>
      </span>
      <br />
      A continuación, hablaremos sobre cómo te sientes con el cambio de pasar de la básica a la media. Por favor, lee cada afirmación y selecciona la opción que más te represente, utilizando las siguientes opciones de 'Nada o nunca' hasta 'Muchísimo o siempre':
      <br />
      <br />
      <div class="qstn-likert-label top">
        <div>Nada o nunca</div>
      </div>
      <div class="btn-group">
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>Nada o nunca</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>Poco o raras veces</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>Algunas veces</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>Bastante o frecuentemente</span></span></label>
        <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>Muchísimo o siempre</span></span></label>
      </div>
      <div class="qstn-likert-label bottom">
        <div>Muchísimo o siempre</div>
      </div>
    </span>
  </div>
`
        }
      ]
    }
  ]
};

const ITEMS = [
  {
    code: 'IATA_01',
    statement:
      'Me pone nervioso/a pensar que tendré distintos profesores en la educación media'
  },
  {
    code: 'IATA_02',
    statement:
      'Estoy preocupado/a por las nuevas responsabilidades que tendré en la educación media'
  },
  {
    code: 'IATA_03',
    statement:
      'Me estresa pensar cómo voy a organizar mi tiempo para las tareas y estudios en la educación media'
  },
  {
    code: 'IATA_04',
    statement: 'Me asusta tener que ser más independiente en la educación media'
  },
  {
    code: 'IATA_05',
    statement:
      'Me preocupan los cambios que puedan surgir en la relación con mis amistades en la educación media'
  },
  {
    code: 'IATA_06',
    statement: 'Me da miedo pasar a la educación media'
  },
  {
    code: 'IATA_08',
    statement: 'Me preocupa no lograr buenas notas en la media'
  },
  {
    code: 'IATA_07',
    statement:
      'Me pone nervioso/a pensar en el tipo de pruebas y trabajos que tendré que hacer en la educación media'
  },
  {
    code: 'IATA_10',
    statement:
      'Me preocupa no tener claro qué ramos me gustarán más cuando tenga que tomar cursos electivos'
  },
  {
    code: 'IATA_09',
    statement:
      'Me estresa pensar que en la educación media mis notas serán más importantes para mi futuro'
  },
  {
    code: 'IATA_11',
    statement:
      'Me preocupa tener que empezar a pensar en lo que quiero estudiar o hacer al salir del colegio'
  }
];

const baseInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  showProgressBar: 'top',
  progressBarType: 'pages',
  goNextPageAutomatic: true,
  firstPageIsStarted: false,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  // showQuestionNumbers: 'off',
  requiredText: ``,
  pages: ITEMS.map(item => {
    const { code, statement } = item;
    return {
      name: code,
      title: '',
      elements: [
        questionHeader,
        {
          type: 'rating',
          name: code,
          title: statement,
          isRequired: true,
          minRateDescription: 'Nada o nunca',
          maxRateDescription: 'Muchísimo o siempre',
          rateValues: ratingValues
        }
      ]
    };
  })
};

export default baseInfo;
